import BaseModel from '@/orm/models/BaseModel';

export default class PayFrequency extends BaseModel {
  static entity = 'payFrequencies';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      default: this.boolean(false).nullable(),
    };
  }

  static apiConfig = {}
}
